import { Injectable } from "@angular/core";
import { ListSnackbarComponent } from "../shared/component/list-snackbar/list-snackbar.component";

@Injectable()
export class ListSnackbarService {

    private activeListSnackbar: ListSnackbarComponent;

    updateActiveListSnackbar(newSnackbar: ListSnackbarComponent): void {
        if (this.activeListSnackbar) {
            this.activeListSnackbar.performUnselect();
        }
        this.activeListSnackbar = newSnackbar;
    }
}